import { BrowserRouter as Router,Route,Routes, Navigate } from 'react-router-dom';
import { v4 as uuid } from 'uuid';
import './App.css';
import Editor from './component/Editor';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Navigate replace to={`/docs/${uuid()}`} />} />
        <Route path="/docs/:id" exact element={<Editor />} />
      </Routes>
    </Router>
  );
}

export default App;
